module.exports = __webpack_public_path__ + "static/media/GerenceLogo.e2048bc5.png";